// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CompanyBusinessTypeController from "./company_business_type_controller"
application.register("company-business-type", CompanyBusinessTypeController)

import CompanySignupSportsController from "./company_signup_sports_controller"
application.register("company-signup-sports", CompanySignupSportsController)

import CompanySignupCoverageController from "./company_signup_coverage_controller"
application.register("company-signup-coverage", CompanySignupCoverageController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ModalAutoshowController from "./modal_autoshow_controller"
application.register("modal-autoshow", ModalAutoshowController)

import OffcanvasAutoshowController from "./offcanvas_autoshow_controller"
application.register("offcanvas-autoshow", OffcanvasAutoshowController)

import ExercisePickerController from "./exercise_picker_controller"
application.register("exercise-picker", ExercisePickerController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import FederalTaxIdMaskController from "./federal_tax_id_mask_controller"
application.register("federal-tax-id-mask", FederalTaxIdMaskController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import LeadPipelineController from "./lead_pipeline_controller"
application.register("lead-pipeline", LeadPipelineController)

import DashboardCardsController from "./dashboard_cards_controller"
application.register("dashboard-cards", DashboardCardsController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DateShortcutsController from "./date_shortcuts_controller"
application.register("date-shortcuts", DateShortcutsController)

import ProfileTabsController from "./profile_tabs_controller"
application.register("profile-tabs", ProfileTabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import SportFavoritesController from "./sport_favorites_controller"
application.register("sport-favorites", SportFavoritesController)

import ProfileAvatarController from "./profile_avatar_controller"
application.register("profile-avatar", ProfileAvatarController)

import CommentsThreadController from "./comments_thread_controller"
application.register("comments-thread", CommentsThreadController)

import GallerySortController from "./gallery_sort_controller"
application.register("gallery-sort", GallerySortController)

import ResendCountdownController from "./resend_countdown_controller"
application.register("resend-countdown", ResendCountdownController)

import SubmitStateController from "./submit_state_controller"
application.register("submit-state", SubmitStateController)

import AthleteWorkoutFormController from "./athlete_workout_form_controller"
application.register("athlete-workout-form", AthleteWorkoutFormController)

import QuickWorkoutOffcanvasController from "./quick_workout_offcanvas_controller"
application.register("quick-workout-offcanvas", QuickWorkoutOffcanvasController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)
